import { useGameLoadingTimer } from '@/app/hooks/use-game-loading-timer';

import s from './index.module.scss';

const formatTime = (ms: number) => {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const milliseconds = Math.floor((ms % 1000) / 10);

  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}.${String(milliseconds).padStart(2, '0')}`;
};

export const StopwatchToStart = () => {
  const { elapsedMs } = useGameLoadingTimer();

  return <div className={s.stopwatch}>{formatTime(elapsedMs)}</div>;
};
